import {domainTrackMap} from "./domainTrackMapData";
import { useState, useEffect } from "react";

export const urlBasedTrackListFilter = (TRACK_EVENT_SELECTION_KEY, trackList) => {
  const currentDomain = window.location.href;
  const allTracksName = "all tracks";

  const forcedTrackId = domainTrackMap[currentDomain];

  const localStorageTrackNameData = localStorage.getItem(
    TRACK_EVENT_SELECTION_KEY,
  );
  const localStorageTrackName = localStorageTrackNameData
    ? JSON.parse(localStorageTrackNameData).trackName
    : null;
  const localStorageTrackId = localStorageTrackNameData
    ? JSON.parse(localStorageTrackNameData).trackId
    : null;

    const shouldEnableTrackNameDropdown = 
    forcedTrackId && forcedTrackId === allTracksName;

  if (localStorageTrackName && localStorageTrackName !== forcedTrackId && forcedTrackId !== allTracksName) {
    localStorage.setItem(
      TRACK_EVENT_SELECTION_KEY,
      JSON.stringify({ trackName: forcedTrackId, trackId: localStorageTrackId }),
    );
  }
  const filteredTrackList =
    forcedTrackId !== allTracksName
      ? trackList.filter((item) => item.trackName === forcedTrackId)
      : trackList;
  return {filteredTrackList,
  shouldEnableTrackNameDropdown
};
};

// hooks/useDomainConfig.js
export const useDomainConfig = () => {
  const [domainConfig, setDomainConfig] = useState(null);
  
  useEffect(() => {
    const domain = window.location.href;
    const config = domainTrackMap[domain];
    setDomainConfig(config);
  }, []);
  
  return domainConfig;
};
